<template>
  <v-dialog v-model="isOpen" max-width="800px" persistent>
    <v-card class="pa-4 rounded-lg">
      <v-card-title class="headline text-orange-darken-2 pb-2">
        <v-icon left class="mr-2" color="#1D1B59">fas fa-box</v-icon>
        {{ $t("views.trips.create_trip.products_list") }}
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon color="#1D1B59">fas fa-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mb-4" />
      <v-card-text>
        <v-list dense v-if="products.length">
          <v-list-item v-for="(product, index) in products" :key="index">
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ product.description_product }} ({{ product.code_product }})
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("views.trips.create_trip.barcode") }}: {{ product.barcode }} |
                {{ $t("views.trips.create_trip.unit") }}: {{ product.unit }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ $t("views.trips.create_trip.amount_order") }}: {{ product.amount_order }} |
                {{ $t("views.trips.create_trip.amount_deliver") }}: {{ product.amount_deliver }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ $t("views.trips.create_trip.routing_variable") }}: {{ product.routing_variable }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-alert v-else type="info">
          {{ $t("views.trips.create_trip.no_products_found") }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ViewProductsModal",
  props: {
    isOpen: Boolean,
    products: {
      type: Array,
      default: () => []
    }
  }
};
</script>
